(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("whatwg-fetch"));
	else if(typeof define === 'function' && define.amd)
		define("wallet", ["whatwg-fetch"], factory);
	else if(typeof exports === 'object')
		exports["wallet"] = factory(require("whatwg-fetch"));
	else
		root["wallet"] = factory(root["whatwg-fetch"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_6__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition